import { TLocationPosition, TLocationWithPosition } from '../LocationsMap.interfaces';

type TCoordinateSource = {
  lat?: unknown;
  lng?: unknown;
  lon?: unknown;
  latitude?: unknown;
  longitude?: unknown;
};

const toFiniteNumber = (value: unknown): number | null => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

export const parseCoordinatePair = (
  coordinates?: TCoordinateSource | null,
): TLocationPosition | null => {
  if (!coordinates || typeof coordinates !== 'object') return null;

  const lat = toFiniteNumber(coordinates.lat ?? coordinates.latitude);
  const lng = toFiniteNumber(coordinates.lng ?? coordinates.lon ?? coordinates.longitude);

  if (lat === null || lng === null) return null;

  return { lat, lng };
};

export const getLocationPosition = (
  location?: (TLocationWithPosition & TCoordinateSource) | null,
): TLocationPosition | null => {
  if (!location) return null;

  return parseCoordinatePair(location.position) ?? parseCoordinatePair(location);
};

export const isValidLatLngTuple = ([lat, lng]: [number, number]) =>
  Number.isFinite(lat) && Number.isFinite(lng);
